import sqftConfig from "../../../store/sqftConfig";
import RenderFigures from "../../../helpers/renderFigures";
import {SQFT_APPLIANCES} from "../../../../../constants";
import RenderParts from "../../../helpers/renderParts";

class RenderSVG {
  __padding = 0;
  constructor(movableImage) {
    this.movableImage = movableImage;
    const applianceImagePadding = movableImage.subType === SQFT_APPLIANCES.hood ? 6 : 3
    this.__padding = movableImage.subType ? applianceImagePadding : 0;
  }

  render = (ctx) => {
    let svgImageDataURI = "";
    const scale = sqftConfig.scale;

    if (this.movableImage.isIE() && this.movableImage.isSVG(this.movableImage.image)) {
      svgImageDataURI = atob(this.movableImage.getSrc(this.movableImage.image).replace(/data:image\/svg\+xml;base64,/, ''));
    }

    //let canvas = workspace.getCanvas();

    ctx.save();
    let posField = this.movableImage.getPosField();
    ctx.translate(posField.x, posField.y);
    ctx.rotate(-this.movableImage.rotatedDegrees * Math.PI / 180);
    let imgOffset = {
      x: this.movableImage.size.width / -2 * scale,
      y: this.movableImage.size.depth / -2 * scale
    };

    this.renderHovering(ctx, imgOffset);

    if (!this.movableImage.isIE()) {
      if (this.movableImage.subType === SQFT_APPLIANCES.sink) {
        RenderFigures.sink(ctx, imgOffset.x, imgOffset.y, this.movableImage.size.width * scale, this.movableImage.size.depth * scale);
      } else if (this.movableImage.subType === SQFT_APPLIANCES.doubleSink) {
        RenderFigures.doubleSink(ctx, imgOffset.x, imgOffset.y, this.movableImage.size.width * scale, this.movableImage.size.depth * scale);
      } else {
        const padding = this.__padding * scale;

        const containerSize = {
          width: this.movableImage.size.width * scale,
          depth: this.movableImage.size.depth * scale,
        };

        const imageSize = this.getContainSize();

        const imgX = imgOffset.x + padding;
        const imgY = imgOffset.y + padding;

        const containerWithPadding = {
          width: containerSize.width,
          depth: containerSize.depth
        };

        // Draw the background and border (large rectangle)
        RenderParts.drawStripedRectangle(ctx, imgOffset.x, imgOffset.y, containerWithPadding.width, containerWithPadding.depth);
        RenderFigures.drawBorder(ctx, imgOffset, containerWithPadding.width, containerWithPadding.depth);

        // Draw the picture itself slightly inside
        ctx.drawImage(this.movableImage.image, imgX, imgY, imageSize.width - 2 * padding, imageSize.depth - 2 * padding);

      }
    } else if (svgImageDataURI) {
      ctx.drawSvg(svgImageDataURI, imgOffset.x, imgOffset.y, this.movableImage.size.width * scale, this.movableImage.size.depth * scale);
    }
    ctx.restore();

    //render border points in dev mode
    if (sqftConfig.isDevMode()) {
      //dev movable point
      // ctx.beginPath();
      // ctx.strokeStyle = '#000'
      // ctx.arc(imgOffset.x, imgOffset.y, 20, 0, 2 * Math.PI);
      // ctx.stroke();
      // ctx.closePath();
      //
      // //dev border points
      // let testImagePoints = this.movableImage.getLinePointsPointField();
      // for (let testPoint of testImagePoints) {
      //   ctx.beginPath();
      //   ctx.strokeStyle = '#a02f2f';
      //   ctx.lineWidth = 1;
      //   ctx.arc(testPoint.x, testPoint.y, 10, 0, 2 * Math.PI);
      //   ctx.stroke();
      //   ctx.closePath();
      //   //debugger // eslint-disable-line no-debugger
      // }
    }
  }

  getContainSize = () => {
    const aspectRatio = this.movableImage.initialSize.width / this.movableImage.initialSize.depth;
    const scale = sqftConfig.scale;
    let newWidth, newDepth;
    if (this.movableImage.size.width / this.movableImage.size.depth > aspectRatio) {
      // The width is larger than needed by the aspect ratio, so we base it on the depth
      newDepth = this.movableImage.size.depth;
      newWidth = newDepth * aspectRatio;
    } else {
      // The depth is larger than needed based on the aspect ratio, so we base it on the width
      newWidth = this.movableImage.size.width;
      newDepth = newWidth / aspectRatio;
    }

    return {width: newWidth * scale, depth: newDepth * scale}
  }

  renderHovering = (ctx, imgOffset) => {
    let scale = sqftConfig.scale;

    if (this.movableImage.isHovering() && !this.movableImage.isAnyLineHovering()) {
      ctx.beginPath();
      ctx.rect(imgOffset.x, imgOffset.y, this.movableImage.size.width * scale, this.movableImage.size.depth * scale);
      ctx.strokeStyle = this.movableImage.hoverColor;
      ctx.lineWidth = 5;
      ctx.stroke();
      ctx.closePath();
    }
  }

  renderAttachedTo = () => {
    // if (this.movableImage.image) {
    //   let midPoint = getMidPoint(this.movableImage.attachedTo.from, this.movableImage.attachedTo.to);
    //   let lineOffset = this.movableImage.attachedTo.getOffset();
    //   let imgOffset = {
    //     x: 0,
    //     y: -32
    //   },
    //   pointData = {
    //     x: (midPoint.x * scale) + lineOffset.x - 4,
    //     y: (midPoint.y * scale) + lineOffset.y - (size.depth * scale) - 4,
    //     radius: size.width * scale / 2 + 8,
    //     arcStart: 0,
    //     arcEnd: 2 * Math.PI
    //   };
    //   if (this.movableImage.attachedTo.getOrientation) {
    //     if (this.movableImage.attachedTo.getOrientation() == 1) { //horizontal
    //       pointData.x -= 64;
    //       pointData.y += 5 * scale;
    //     } else {
    //       // console.log(scale);
    //       if (scale >= 6) {
    //         pointData.y -= ((6 - scale) * scale / 2);
    //       } else {
    //         pointData.y += (6 - scale) * 6;
    //       }
    //     }
    //   }
    //   if (!this.movableImage.isIE() || !this.movableImage.isSVG()) {
    //     ctx.drawImage(this.movableImage.image, pointData.x - (size.width * scale / 2) + imgOffset.x, (midPoint.y * scale) + lineOffset.y - (size.depth * scale / 2) - 4 + imgOffset.y + (this.movableImage.attachedTo.getOrientation() == 1 ? 32 : 0), size.width * scale, size.depth * scale);
    //   } else {
    //     ctx.drawSvg(svgImageDataURI, pointData.x - (size.width * scale / 2) + imgOffset.x, (midPoint.y * scale) + lineOffset.y - (size.depth * scale / 2) - 4 + imgOffset.y + (this.movableImage.attachedTo.getOrientation() == 1 ? 32 : 0), size.width * scale, size.depth * scale);
    //   }
    //   ctx.save();
    //   ctx.beginPath();
    //   ctx.arc(pointData.x, pointData.y, pointData.radius, pointData.arcStart, pointData.arcEnd);
    //   ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
    //   ctx.lineWidth = 4;
    //   ctx.stroke();
    //   ctx.fillStyle = "RGBA(0,0,192,0.1)";
    //   ctx.fill();
    //   ctx.closePath();
    //   ctx.restore();
    // }
  }
}

export default RenderSVG
